import { bindRequestLogic } from './utils'
import CompanyVehicleBrandLinks from '../actionTypes/companyVehicleBrandLink'
import { companyVehicleBrandLinkAPI } from '../api'

const getCompanyVehicleBrandLinks = bindRequestLogic({
  clientFunc: companyVehicleBrandLinkAPI.getCompanyVehicleBrandLinks,
  type: CompanyVehicleBrandLinks.GET_COMPANY_VEHICLE_BRAND_LINKS_REQUEST,
  successType: CompanyVehicleBrandLinks.GET_COMPANY_VEHICLE_BRAND_LINKS_SUCCESS,
  failType: CompanyVehicleBrandLinks.GET_COMPANY_VEHICLE_BRAND_LINKS_FAILED,
  isQueryParam: true
})

const getCompanyVehicleBrandLinkDetail = bindRequestLogic({
  clientFunc: companyVehicleBrandLinkAPI.getCompanyVehicleBrandLinkDetail,
  type: CompanyVehicleBrandLinks.GET_COMPANY_VEHICLE_BRAND_LINK_DETAIL_REQUEST,
  successType:
    CompanyVehicleBrandLinks.GET_COMPANY_VEHICLE_BRAND_LINK_DETAIL_SUCCESS,
  failType:
    CompanyVehicleBrandLinks.GET_COMPANY_VEHICLE_BRAND_LINK_DETAIL_FAILED,
  modelName: 'CompanyVehicleBrandLink'
})

const addCompanyVehicleBrandLink = bindRequestLogic({
  clientFunc: companyVehicleBrandLinkAPI.addCompanyVehicleBrandLink,
  type: CompanyVehicleBrandLinks.ADD_COMPANY_VEHICLE_BRAND_LINK_REQUEST,
  successType: CompanyVehicleBrandLinks.ADD_COMPANY_VEHICLE_BRAND_LINK_SUCCESS,
  failType: CompanyVehicleBrandLinks.ADD_COMPANY_VEHICLE_BRAND_LINK_FAILED
})

const deleteCompanyVehicleBrandLink = bindRequestLogic({
  clientFunc: companyVehicleBrandLinkAPI.deleteCompanyVehicleBrandLink,
  type: CompanyVehicleBrandLinks.DELETE_COMPANY_VEHICLE_BRAND_LINK_REQUEST,
  successType:
    CompanyVehicleBrandLinks.DELETE_COMPANY_VEHICLE_BRAND_LINK_SUCCESS,
  failType: CompanyVehicleBrandLinks.DELETE_COMPANY_VEHICLE_BRAND_LINK_FAILED
})

const updateCompanyVehicleBrandLink = bindRequestLogic({
  clientFunc: companyVehicleBrandLinkAPI.updateCompanyVehicleBrandLink,
  type: CompanyVehicleBrandLinks.UPDATE_COMPANY_VEHICLE_BRAND_LINK_REQUEST,
  successType:
    CompanyVehicleBrandLinks.UPDATE_COMPANY_VEHICLE_BRAND_LINK_SUCCESS,
  failType: CompanyVehicleBrandLinks.UPDATE_COMPANY_VEHICLE_BRAND_LINK_FAILED
})

export default [
  getCompanyVehicleBrandLinks,
  getCompanyVehicleBrandLinkDetail,
  addCompanyVehicleBrandLink,
  updateCompanyVehicleBrandLink,
  deleteCompanyVehicleBrandLink
]
